import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

const TecRoute = () => {
  const { user, cargando } = useAuth();

  if (cargando) return <div>Cargando...</div>;

  // Permitir acceso si el rol es "user" o "admin"
  return user && (user.role === "tec" || user.role === "admin") ? (
    <Outlet />
  ) : (
    <Navigate to="/login" replace />
  );
};

export default TecRoute;
